import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-secondary flex flex-col gap-3 rounded-md border p-4" }
const _hoisted_2 = { class: "flex items-center justify-between gap-3" }
const _hoisted_3 = { class: "text-secondary text-xs" }
const _hoisted_4 = { class: "text-secondary text-xs font-semibold" }

import { InputRow, MultiCombobox } from '@/components/ui/form';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherAdministrateCardFormItem',
  props: {
    form: {},
    mainForm: {},
    index: {},
    employeeOptions: {},
    userOptions: {},
    isLoadingUserOptions: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.form.name), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.form.number), 1)
    ]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "employee_ids",
      label: "credit-cards.form.employee_ids",
      "error-key": `vouchers.administrate.${_ctx.index}.employee_ids`
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.employee_ids,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.employee_ids) = $event)),
          placeholder: _ctx.$t('credit-cards.form.employee_ids'),
          options: _ctx.employeeOptions,
          "label-by": "full_name",
          "value-by": "id"
        }, null, 8, ["modelValue", "placeholder", "options"])
      ]),
      _: 1
    }, 8, ["form", "error-key"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "user_ids",
      label: "credit-cards.form.user_ids",
      "error-key": `vouchers.administrate.${_ctx.index}.user_ids`
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: _ctx.form.user_ids,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.user_ids) = $event)),
          placeholder: _ctx.$t('credit-cards.form.user_ids'),
          options: _ctx.userOptions,
          "label-by": "name",
          "value-by": "id",
          loading: _ctx.isLoadingUserOptions
        }, null, 8, ["modelValue", "placeholder", "options", "loading"])
      ]),
      _: 1
    }, 8, ["form", "error-key"])
  ]))
}
}

})